<template>
    <div id="app">
        <v-app light>
            <Navbar/>
            <router-view/>
            <Footer/>
        </v-app>
    </div>
</template>

<script>
    import Navbar from '@/components/layout/Navbar'
    import Footer from '@/components/layout/Footer'
    export default {
        name: 'App',
        components: {
            Navbar, Footer
        },
        data: () => ({
            title: "Data Chester Inc."
        })
    }
</script>


// WEBPACK FOOTER //
// src/App.vue